// import * as api from '@/api/details'
// import cookie from 'js-cookie'

const state = {
    rankObJ: null
}

const getters = {
    // rankList: (state) => {
    //     return {
    //         rankPlace: state.rankPlace,
    //         userImg: state.userImg,
    //         name: state.name,
    //         rankName: state.rankName
    //     }
    // }
}

const actions = {
    // rankList: ({ commit }) => {
    //     // api.listData({}, (_data) => commit(_data))
    // }
}

const mutations = {
    'class/GET_RANKOBJ': function (state, _data) {
        state.rankObJ = _data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/class.js